export type NotificationStatusType = 'success' | 'info' | 'warning' | 'error'

export type NotificationIcon = '' // icon put in UI

export const NOTIFICATION_MESSAGE = 'NOTIF_MSDK'

export class NotificationEvent extends Event {
  inner?: NotificationEntity
}

export interface NotificationEntity {
  id?: string
  title?: string
  message?: string | React.ReactNode
  status?: NotificationStatusType
  time?: number
  waitUserAck?: boolean
  closeOnClick?: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClose?: (...args: any[]) => any
}

export type NotificationArgs = Omit<NotificationEntity, 'id'>
/**
 * The function `sendNotification` sends a notification event with a unique ID and additional
 * information.
 * @param {NotificationArgs} notification - The `notification` parameter is an object that contains the
 * information for the notification. It can have the following properties:
 */
export function sendNotification(notification: NotificationArgs) {
  const evt = new NotificationEvent(NOTIFICATION_MESSAGE)
  evt.inner = { ...notification, id: crypto.randomUUID() }
  try {
    window.dispatchEvent(evt)
  } catch (error) {
    throw new Error('💥 notification dispatchEvent', { cause: error })
  }
}

/**
 * The function sends a generic error notification with the error message and name, or a default
 * message if no error is provided.
 * @param {Error | undefined} e - The parameter `e` is of type `Error | undefined`. This means it can
 * either be an `Error` object or `undefined`.
 */
export function sendGenericErrorNotification(e: Error | undefined) {
  if (e) {
    sendNotification({ message: `💥 ${e.message}`, status: 'error', title: `ERROR: ${e.name}` })
  } else {
    sendNotification({ message: `👾🛸👾🛸`, status: 'error', title: `ERROR: UNKNOWN 👽` })
  }
}
